import { Controller } from "@hotwired/stimulus";

// The checked radio (downsell_plan[retention_offer_source]) is what the server reads to decide which
// source to persist; this controller only manages which pane is visible and a local file preview.
export default class extends Controller {
  static targets = ["imagePane", "designPane", "textPane", "fileName", "previewImage", "previewEmpty"];

  connect() {
    this.showSelectedPane();
  }

  selectSource() {
    this.showSelectedPane();
  }

  showSelectedPane() {
    const source = this.selectedSource();
    this.imagePaneTargets.forEach((el) => (el.hidden = source !== "image"));
    this.designPaneTargets.forEach((el) => (el.hidden = source !== "design"));
    this.textPaneTargets.forEach((el) => (el.hidden = source !== "text"));
  }

  selectedSource() {
    const checked = this.element.querySelector(
      'input[name="downsell_plan[retention_offer_source]"]:checked',
    );
    return checked ? checked.value : "image";
  }

  // Shows the just-picked file locally so the operator sees it before saving; the real upload happens on
  // submit (direct upload), after which the server rewrites it into the retention offer image.
  previewFile(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    if (this.hasFileNameTarget) this.fileNameTarget.textContent = file.name;
    if (this.hasPreviewImageTarget) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewImageTarget.src = e.target.result;
        this.previewImageTarget.hidden = false;
        if (this.hasPreviewEmptyTarget) this.previewEmptyTarget.hidden = true;
      };
      reader.readAsDataURL(file);
    }
  }
}
